<template>
  <div class="container-fluid">
    <div class="row" id="Leave">
      <div class="col-md-3 col-12">
        <div class="mt-2"><i class="fas fa-user" style="color: var(--logo-color) !important"></i> &nbsp; <small id="LblName"> درخواست کننده : </small>[ {{ userDepartment.namFam }} ]</div>
      </div>
      <div class="col-md-3 col-12">
        <div class="mt-2"><i class="fad fa-list-ol" style="color: var(--logo-color) !important"></i>&nbsp; <small id="LblName"> شماره پرسنلی : </small>[ {{ userDepartment.usercode }} ]</div>
      </div>
      <div class="col-md-3 col-12">
        <div class="mt-2"><i class="fad fa-users-class" style="color: var(--logo-color) !important"></i>&nbsp; <small id="LblName"> قسمت : </small>[ {{ userDepartment.departmentName }} ]</div>
      </div>
      <div class="col-md-3 col-12">
        <div class="mt-2"><i class="fad fa-calendar-alt" style="color: var(--logo-color) !important"></i>&nbsp; <small id="LblName"> تاریخ درخواست : </small> {{ $GetJalaliDate() }}</div>
      </div>
    </div>
    <hr class="my-2" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      userDepartment: {},
    }
  },
  created() {
    this.$PostData({ ArryfildValue: null, Method: 'GET', Action: 'GetUserDepAutomation/?Id=' + this.$session.get('UserInfo').tblUserId }).then((result) => {
      if (result.length>0) {
        this.userDepartment = result[0]
      }else{
        this.$toasted.error('امکان ثبت درخواست برای کاربری شما وجود ندارد ، کاربری در دپارتمان وجود ندارد .',{ duration:3500})
        this.$router.push({path:'/app/dashboard'})
      }
    })
  },
}
</script>
